import * as tf from '@tensorflow/tfjs';

let initialized = false;

export async function initializeTensorFlow() {
  if (initialized) {
    return;
  }

  console.log('Initializing TensorFlow.js with webgl backend...');

  // Set backend to webgl before any model loading
  await tf.setBackend('webgl');
  await tf.ready();

  console.log('TensorFlow.js ready with backend:', tf.getBackend());
  initialized = true;
}
